// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1HaX_","title":"Header_title__29NHJ","left":"Header_left__3vX4e","clinicName":"Header_clinicName__21ZQh"};